// extracted by mini-css-extract-plugin
export default {"hover":"CustomBreadcrumb_hover__s6Bmx"};